<template>
    <div class="main homepage-layout pb-8">
        <TRTPageBuilder :response="response"></TRTPageBuilder>
    </div>
</template>

<script>
import TRTPageBuilder from '@/components/cms_components/TRTPageBuilder';
import { getButterCmsPage } from '@/helpers/ButterCmsHelpers';

export default {
    name: 'TRTPage',
    data() {
        return {
            page_title: 'TRT Page',
            response: [],
        };
    },
    created() {
        getButterCmsPage('trt-page').then((res) => this.response = res);
    },
    components: {
        TRTPageBuilder,
    },
};
</script>
